import React, {useContext} from "react";
import {LangCtx} from "../../../lib/context";

const UpcomingAppointments = (props) => {
    const {l} = useContext(LangCtx);

    return (
        <div className="clrCardBlock">
            <div className="clrCard grnGrdntBg">
                <div className="clrCrdHdr">
                    <h2 className="clrCrdTxtL">{l.today} - <span>{l.upcom_apptmnt}</span></h2>
                </div>
                <div className="clrCrdBdy">
                    <div className="clrCrdRow">
                        <div className="clrCrdIconBox">
                            <img src="/images/icons/upcoming-appointments.png" className="invertWhite" alt="icon" />
                        </div>
                        <div className="clrCrdInfoBox">
                            <div className="clrCntBox">
                                <span>{props.totalUpcoming}</span>
                                {/* <div className="clrTxtBox">
                                    <span>{l.upcom_apptmnt}</span>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpcomingAppointments;